import { h } from 'preact';
import { useState } from 'preact/hooks';
import { GlobalState } from '../../states/global-state';
import { useSignalEffect } from '@preact/signals';

import { socket } from '../socket';

const IziToast = props => {
  let iziToast = {};
  if (typeof window !== 'undefined') {
    iziToast = window['iziToast'];
  }

  socket.on('newRegister', message => {
    GlobalState.set.showIziToast({
      title: '',
      context: 'success',
      message,
    });
  });

  useSignalEffect(() => {
    if (GlobalState.showIziToast.value) {
      iziToast[GlobalState.iziToastConfig.context.value]({
        position: 'topRight',
        title: GlobalState.iziToastConfig.title.value,
        message: GlobalState.iziToastConfig.message.value,
      });
    }
  });

  return <div class="d-none" />;
};

export default IziToast;
